require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-when-times-get-tough.json") })
        }
      }, "path---articles-when-times-get-tough");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-when-times-get-tough!./.cache/json/articles-when-times-get-tough.json
// module id = 1930
// module chunks = 231608221292675